import * as React from "react";
import type { SVGProps } from "react";
const SvgCrossSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cross-square_svg__a)">
      <path d="M16.74 17.74c-.26 0-.51-.1-.71-.29L6.56 7.97a.996.996 0 1 1 1.41-1.41l9.47 9.47a.996.996 0 0 1-.71 1.7z" />
      <path d="M7.26 17.74c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l9.48-9.48a.996.996 0 1 1 1.41 1.41l-9.47 9.47c-.2.2-.45.29-.71.29z" />
      <path d="M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4M6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z" />
    </g>
    <defs>
      <clipPath id="cross-square_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCrossSquare;
